
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"22","height":"22","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M3.385 19.571h15.23V8.143H3.385V19.57zM7.538 6V2.786a.354.354 0 00-.097-.257.331.331 0 00-.249-.1H6.5a.331.331 0 00-.249.1.354.354 0 00-.097.257V6c0 .104.032.19.097.257s.148.1.249.1h.692a.331.331 0 00.25-.1A.354.354 0 007.537 6zm8.308 0V2.786a.354.354 0 00-.097-.257.331.331 0 00-.249-.1h-.692a.331.331 0 00-.25.1.354.354 0 00-.096.257V6c0 .104.032.19.097.257s.148.1.249.1h.692a.331.331 0 00.249-.1.354.354 0 00.097-.257zM20 5.286V19.57c0 .387-.137.722-.411 1.005a1.31 1.31 0 01-.974.424H3.385c-.375 0-.7-.141-.974-.424A1.395 1.395 0 012 19.57V5.286c0-.387.137-.722.411-1.005a1.31 1.31 0 01.974-.424h1.384V2.786c0-.491.17-.912.509-1.261C5.617 1.175 6.024 1 6.5 1h.692c.476 0 .884.175 1.223.525.339.35.508.77.508 1.26v1.072h4.154V2.786c0-.491.17-.912.508-1.261.34-.35.747-.525 1.223-.525h.692c.476 0 .883.175 1.222.525.34.35.509.77.509 1.26v1.072h1.384c.375 0 .7.142.974.424.274.283.411.618.411 1.005z","fill":"#282498","fill-rule":"nonzero"}})])
          )
        }
      }
    


// WEBPACK FOOTER //
// ./src/assets/ic_calendar_o.svg